import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { useNavigate } from 'react-router';

interface Props {
  sx?: any;
}

const LogInAs: React.FC<Props> = ({ sx }) => {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem('access-token');
  const fullName = localStorage.getItem('full-name');

  return (
    <Box sx={sx}>
      {accessToken ? (
        <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#EFFDEC', border: '1px solid #69B956', padding: '10px 20px' }}>
          <FontAwesomeIcon icon={faUserCircle} style={{ marginRight: '20px', height: '2.5em' }} />
          <Box>
            <Typography style={{ fontWeight: '400' }}>
              {`You are currently logged in as `}<span style={{ fontWeight: '800' }}>{fullName}</span>{`. Your order will use your attached contact and billing information.`}
            </Typography>
            <Typography style={{ fontWeight: '400' }}>
              <Link style={{ cursor: 'pointer' }}>{`Edit account details`}</Link>
              <Link
                style={{ cursor: 'pointer', marginLeft: '20px' }}
                onClick={() => {
                  localStorage.removeItem('access-token');
                  localStorage.removeItem('full-name'); // Optional: Clear the name too
                  navigate('/');
                }}>
                {`Not `}<span style={{ fontWeight: '800' }}>{fullName}</span>{`? Log out now`}
              </Link>
            </Typography>
          </Box>
        </Box>
      ) : (
        <Box sx={{ padding: '10px 20px', backgroundColor: '#FBE4E4', border: '1px solid #FF4D4D', borderRadius: '5px' }}>
          <Typography style={{ fontWeight: '400', color: '#D8000C' }}>
            Not logged in.{' '}
            <Link
              style={{ cursor: 'pointer', fontWeight: '800', color: '#0056b3' }}
              onClick={() => navigate('/login')}>
              Log in
            </Link>
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default LogInAs;
